import React from 'react';
import logo from './img/caete-florestal-logo.png';
import EsqueceuSenhaForm from './EsqueceuSenhaForm.jsx';
import EsqueceuSenhaSuccess from './EsqueceuSenhaSuccess.jsx';

class EsqueceuSenha extends React.Component {

    constructor() {

        super();

        this.state = {
            email: "",
            errMsg: "",
            success: false
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.enviar = this.enviar.bind(this);
        this.cancelar = this.cancelar.bind(this);

        if (localStorage.usuarioInfo !== null && localStorage.usuarioInfo !== undefined) {
            window.location.href = "/home";
        }

    }

    changeEmail(e) {
        this.setState({ email: e.target.value });
    }

    enviar() {

        let filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        if (this.state.email === "") {

            this.setState({ errMsg: "Por favor, informe o seu E-mail." });

        } else if (!filter.test(this.state.email)) {

            this.setState({ errMsg: "Por favor, informe um E-mail válido." });

        } else { 

            this.setState({ errMsg: "Aguardando..." });

            let obj = {
                "email": this.state.email
            };

            fetch("/api/usuario/esqueceusenha", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg !== "success") {

                    this.setState({ errMsg: responseJson.msg });

                } else {

                    this.setState({ success: true });

                }

            });

        }

    }

    cancelar() {
        window.location.href = "/";
    }

    render() {
        return(
            <div id="esqueceu-senha-div">
                <div id="esqueceu-senha-header-div">
                    <img src={logo} id="esqueceu-senha-logo" alt="logo" />
                </div>
                { this.state.success === false && 
                    <EsqueceuSenhaForm
                        email={ this.state.email }
                        changeEmail={ this.changeEmail }
                        errMsg={ this.state.errMsg }
                        enviar={ this.enviar }
                        cancelar={ this.cancelar } /> }
                {  this.state.success === true &&
                    <EsqueceuSenhaSuccess
                        voltar={ this.cancelar } />}
            </div>
        );
    }

}

export default EsqueceuSenha;

